import { html, repeat, when } from '@microsoft/fast-element';
/**
 * A directive that renders a set of grid-pro-column elements from a given input binding
 *
 * @param itemsBinding - The array to render
 * @param includeRenderers - Optionally tells whether to include cell renderers, if available
 * @public
 */
export function gridProColumns(itemsBinding, includeRenderers = true) {
    return html `
    ${repeat(typeof itemsBinding === 'function' ? itemsBinding : () => itemsBinding, html `
        <grid-pro-column :definition=${(x) => x}>
          ${when((x) => includeRenderers && x.cellRenderer, html `
              <grid-pro-cell
                :renderer="${(x) => x.cellRenderer}"
                :rendererParams="${(x) => x.cellRendererParams}"
              ></grid-pro-cell>
            `)}
        </grid-pro-column>
      `)}
  `;
}
